module.exports = __webpack_public_path__ + "img/gorras.8e98a0d4.jpg";